export const SITE_NAME = `${process.env.REACT_APP_SITE_NAME ?? ''}`;
export const BASE_URL = `${process.env.REACT_APP_BASE_URL ?? ''}`;

export const SITE_URLS = {
    // authentication routes
    createAccount: 'register',
    login: 'login',
    recoverPassword: 'recover-password',
    setNewPassword: 'new-password/:token',
    verifyAccount: 'verify-account',
    twoFactorAuthActivate: 'activate-2fa',
    twoFactorAuthVerify: 'verify-2fa',

    home: 'home',
    myAccount: 'my-account',
    mySpaces: 'my-account/spaces',
    createSpace: 'my-account/spaces/create',
    editSpace: 'my-account/spaces/edit/:uuid',
    alerts: 'my-account/alerts',
    spaces: 'spaces',
    spaceDetail: 'space/:uuid',
    contacts: 'contacts',
    merchantDetail: 'merchant/:uuid',
    policy: 'policy/:pageKey',
    // shopping cart pages
    shoppingCart: 'shopping-cart',
    myProfile: 'my-account/my-profile',
    pageNotFound: 'notfound',
};

export const BASE_FONT_SIZE_KEY = 'base-font-size';
export const BASE_FONT_SIZE_STEPS_PX = [12, 13, 14, 15, 16, 18, 20, 24, 26];
export const DEFAULT_BASE_FONT_SIZE_PX = 16;
export const GRAYSCALE_THEME_KEY = 'use-grayscale';

export const PASSWORD_MIN_LENGTH = 8;
export const REGEX_HAS_UPPERCASE = /[A-Z]/;
export const REGEX_HAS_LOWERCASE = /[a-z]/;
export const REGEX_HAS_DIGIT = /\d/;
export const REGEX_HAS_SPECIAL_CHAR = /\W/;
export const REGEX_IS_EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const API_VERSION = '/api/v1';
export const API_URL = `${process.env.REACT_APP_API_URL ?? ''}${API_VERSION}`;

export const NOTIFICATIONS_DISMISS_SECONDS = 5;
